'use client'

import { Button } from 'antd'
import { isAfter } from 'date-fns'
import { Show } from '@/app/shows/[showName]/[showId]/page'
import { FC } from 'react'

interface ShowTicketsProps {
	show: any
}

const ShowTickets: FC<ShowTicketsProps> = ({ show }) => {
	return (
		<div>
			{isAfter(new Date(show.end_date), new Date()) ? (
				<a
					href={show?.ticket_url}
					target='_blank'
					className='block bg-shadowBlue text-white text-center rounded p-2 duration-300 hover:bg-shadowTan'
				>
					Get Tickets
				</a>
			) : (
				<div className='text-center'>
					<Button type='primary' disabled className='text-black'>
						Production has ended
					</Button>
				</div>
			)}
		</div>
	)
}

export default ShowTickets
